import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../Context/authContext';
import { useUtiContext } from '../../../Context/utiContext';
import logoUtiNeo from '../../../img/logoUtiNeo.png';
import './index.css';

const LayoutAreaAdmin = () => {
    const { logout, user } = useAuthContext();
    const { logout: logoutUtiContext } = useUtiContext();

    const navigate = useNavigate();

    function handleLogout() {
        logout();
        logoutUtiContext();
        console.log('Saindo...');
        navigate('/Sobre');
    }

    return (
        <div style={{ display: 'flex', minHeight: '100vh' }}>
            {/* Menu lateral */}
            <nav className='navAreaAdmin'>
                <div style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                    <img src={logoUtiNeo} alt="Logo" style={{ width: 70 }} />
                </div>
                <h2 className='title'>UTI Neonatal</h2>
                <span style={{ display: 'flex', textAlign: 'center', justifyContent: 'center', alignItems: 'center', gap: '0.5rem' }}>
                    <i class="fas fa-user-circle"></i>
                    <p className='helloUser' style={{ margin: 0 }}>
                        Olá, {user?.user?.nome ? user.user.nome.split(' ')[0] : 'Usuário'}
                    </p>
                </span>

                <div style={{ paddingTop: 20 }}></div>
                <div className="navlinkMenu">
                    <NavLink
                        to="/admin/cadastrar-conteudo"
                        style={({ isActive }) => ({
                            // color: isActive ? '#1abc9c' : 'white',
                            color: isActive ? '#f1761b' : 'white',
                            textDecoration: 'none',
                        })}
                    >
                        <i class="fas fa-file-import" style={{ paddingRight: 10 }} />
                        Cadastrar Conteúdos
                    </NavLink>
                </div>
                <div className="navlinkMenu">
                    <NavLink
                        to="/admin/listar-conteudo"
                        style={({ isActive }) => ({
                            color: isActive ? '#f1761b' : 'white',
                            textDecoration: 'none',
                        })}
                    >
                        <i class="far fa-list-alt" style={{ paddingRight: 10 }} />
                        Listar Conteúdos
                    </NavLink>
                </div>
                <div className="navlinkMenu">
                    <NavLink
                        to="/treinamentos"
                        style={({ isActive }) => ({
                            color: isActive ? '#f1761b' : 'white',
                            textDecoration: 'none',
                        })}
                    >
                        <i class="fas fa-graduation-cap" style={{ paddingRight: 10 }} />
                        Treinamentos
                    </NavLink>
                </div>
                <div className="navlinkMenu">
                    <NavLink
                        to="/"
                        style={({ isActive }) => ({
                            color: isActive ? '#f1761b' : 'white',
                            textDecoration: 'none',
                        })}
                    >
                        <i class="fas fa-home" style={{ paddingRight: 10 }} />
                        Página Inicial
                    </NavLink>
                </div>

                <button
                    onClick={handleLogout}
                    style={{
                        marginTop: 'auto',
                        padding: '0.5rem',
                        background: '#e74c3c',
                        border: 'none',
                        color: 'white',
                        cursor: 'pointer',
                        borderRadius: '4px',
                    }}
                >
                    <i class="fas fa-power-off" style={{ paddingRight: 10 }} />
                    Sair
                </button>
            </nav>

            {/* Conteúdo principal */}
            <main
                style={{
                    flex: 1,
                    padding: '2rem',
                    background: '#ecf0f1',
                }}
            >
                <Outlet />
            </main>
        </div>
    );
};

export default LayoutAreaAdmin;
